// packages
import { Routes, RouterModule } from '@angular/router';
import { BrowserModule } from '@angular/platform-browser';
import { NgModule, Component } from '@angular/core';
import { DatePipe } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http'; // http calls

import {Moment} from 'moment';

// tslint:disable-next-line:max-line-length
import { DxTextBoxModule,
  DxButtonModule,
  DxDataGridModule,
  DxTextAreaModule,
  DxNumberBoxModule,
  DxDateBoxModule,
  DxCheckBoxModule,
  DxDropDownBoxModule,
  DxSelectBoxModule,
  DxTemplateModule,
  DxValidatorModule,
  DxValidationSummaryModule,
  DxFormComponent,
  DxFormModule,
  DxPopupModule,
  DxFileUploaderModule,
  DxLoadPanelModule,
  DxListModule } from 'devextreme-angular';

// mat dialog box - npm install --save @angular/material @angular/cdk @angular/animations
import { MatDialogModule } from '@angular/material/dialog';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

// Shared services
import { SharedService } from './shared/shared.service';
import { UsefulToolsService } from './shared/other/usefultools.service';
import { DriversService} from './home/content-area/system-setup/drivers.service';
import { UsersService} from './home/content-area/system-setup/users.service';
import { MethodOfPaymentService } from './home/content-area/system-setup/method-of-payment.service';
import { VehicleService } from './home/content-area/system-setup/vehicle.service';
import { InvoiceService } from './home/content-area/operations/invoices.service';
import { TripService } from './home/content-area/trips/trips-main/trip.services';
import { AccountService } from './home/content-area/operations/accounts.service';
import { TripDateService } from './home/content-area/trips/trips-main/trip-dates';
import { TripEditService } from './home/content-area/trips/trips-edit/trips-edit.services';
import { OwnHttpInterceptor } from './shared/other/own-http-inceptor/own-http-interceptor';
import { HTTP_INTERCEPTORS } from '@angular/common/http';

// components
import { AppComponent } from './app.component';
import { LoginComponent } from './login/login';
import { StylesViewerComponent } from './shared/other/styles-viewer/styles-viewer';
import { CaptureBatchTripsComponent } from './home/content-area/trips/capture-batch-trips/capture-batch-trips.component';

// popups
import { PopAlertComponent } from './shared/popups/alert/pop-alert';
import { PopupTextarea } from './shared/popups/textarea/popup-textarea';

import { MenuBarComponent } from './home/menu-bar/menu-bar.component';
import { DashboardComponent } from './home/content-area/dashboard/dashboard.component';
import { HomeComponent } from './home/home.component';
import { ContentAreaComponent } from './home/content-area/content-area.component';
import { TripsComponent } from './home/content-area/trips/trips-main/trips.component';
import { OperationsComponent } from './home/content-area/operations/operations.component';
import { AdministrationComponent } from './home/content-area/administration/administration.component';
import { ReportsComponent } from './home/content-area/reports/reports.component';
import { SystemSetupComponent } from './home/content-area/system-setup/system-setup.component';
import { AccountsComponent } from './home/content-area/operations/accounts/account-main/accounts.component';
import { InvoicesComponent } from './home/content-area/operations/invoices/invoices-main/invoices.component';
import { MyDetailsComponent } from './home/content-area/administration/my-details/my-details.component';
import { RoleComponent } from './home/content-area/administration/role/role.component';
// import { UserComponent } from './home/content-area/administration/user/user.component';
import { DriverComponent } from './home/content-area/system-setup/driver/driver-main/driver.component';
import { UserComponent } from './home/content-area/system-setup/user/user-main/user.component';
// tslint:disable-next-line:max-line-length
import { MethodOfPaymentComponent } from './home/content-area/system-setup/method-of-payment/method-of-payment-main/method-of-payment.component';
import { VehicleComponent } from './home/content-area/system-setup/vehicle/vehicle-main/vehicle.component';
import { TripsEditComponent } from './home/content-area/trips/trips-edit/trips-edit.component';
import { InvoicesEditComponent } from './home/content-area/operations/invoices/invoices-edit/invoices-edit.component';
import { InvoicesPrintComponent } from './home/content-area/operations/invoices/invoices-print/invoices-print.component';
import { AccountsEditComponent } from './home/content-area/operations/accounts/accounts-edit/accounts-edit.component';
// tslint:disable-next-line:max-line-length
import { MethodOfPaymentEditComponent } from './home/content-area/system-setup/method-of-payment/method-of-payment-edit/method-of-payment-edit.component';
import { DriverEditComponent } from './home/content-area/system-setup/driver/driver-edit/driver-edit.component';
import { VehicleEditComponent } from './home/content-area/system-setup/vehicle/vehicle-edit/vehicle-edit.component';
import { UserEditComponent } from './home/content-area/system-setup/user/user-edit/user-edit.component';


const appRoutes: Routes = [
  { path: 'styles-viewer', component: StylesViewerComponent },
  // login
  { path: '', component: LoginComponent },
  // home
  { path: 'home', component: HomeComponent, children: [
    // operations
    { path: 'operations', component: OperationsComponent, children: [
      { path: 'accounts', component: AccountsComponent },
      { path: 'accounts/accounts-edit', component: AccountsEditComponent},
      { path: 'invoices', component: InvoicesComponent },
      { path: 'invoices/invoices-edit', component: InvoicesEditComponent},
      { path: 'invoices/invoices-print', component: InvoicesPrintComponent}
    ] },
    // dashboard
    { path: 'dashboard', component: DashboardComponent },
    // administration
    { path: 'administration', component: AdministrationComponent, children: [
      { path: 'my-details', component: MyDetailsComponent },
      { path: 'role', component: RoleComponent },
      // { path: 'user', component: UserComponent },
    ] },
     // reports
     { path: 'reports', component: ReportsComponent },
    // trips
    { path: 'trips', component: TripsComponent },
    { path: 'trips/trips-edit', component: TripsEditComponent },
    { path: 'trips/capture-batch-trips', component: CaptureBatchTripsComponent },
    { path: 'system-setup', component: SystemSetupComponent, children: [
      { path: 'driver', component: DriverComponent },
      { path: 'driver/driver-edit', component: DriverEditComponent },
      { path: 'vehicle', component: VehicleComponent },
      { path: 'vehicle/vehicle-edit', component: VehicleEditComponent },
      { path: 'method-of-payment', component: MethodOfPaymentComponent },
      { path: 'method-of-payment/method-of-payment-edit', component: MethodOfPaymentEditComponent },
      { path: 'user', component: UserComponent },
      { path: 'user/user-edit', component: UserEditComponent }
    ]}
    ] },
];



@NgModule({
  declarations: [
    AppComponent,
    LoginComponent,
    CaptureBatchTripsComponent,
    PopAlertComponent,
    PopupTextarea,
    MenuBarComponent,
    DashboardComponent,
    HomeComponent,
    ContentAreaComponent,
    TripsComponent,
    OperationsComponent,
    AdministrationComponent,
    ReportsComponent,
    SystemSetupComponent,
    AccountsComponent,
    InvoicesComponent,
    MyDetailsComponent,
    RoleComponent,
    // UserComponent,
    DriverComponent,
    UserComponent,
    MethodOfPaymentComponent,
    VehicleComponent,
    TripsEditComponent,
    InvoicesEditComponent,
    InvoicesPrintComponent,
    AccountsEditComponent,
    MethodOfPaymentEditComponent,
    DriverEditComponent,
    VehicleEditComponent,
    StylesViewerComponent,
    UserEditComponent
  ],
  imports: [
    BrowserModule,
    FormsModule,
    HttpClientModule,
    // mat dialog box
    MatDialogModule,
    BrowserAnimationsModule,
    // dev extreem
    DxTextBoxModule,
    DxButtonModule,
    DxDataGridModule,
    DxTextAreaModule,
    DxNumberBoxModule,
    DxDateBoxModule,
    DxCheckBoxModule,
    DxDropDownBoxModule,
    DxTemplateModule,
    DxSelectBoxModule,
    DxListModule,
    DxValidatorModule,
    DxValidationSummaryModule,
    DxFormModule,
    DxPopupModule,
    DxFileUploaderModule,
    DxLoadPanelModule,
    // in web api
    RouterModule.forRoot(appRoutes, { useHash: true })
  ],
  providers: [
    SharedService,
    HttpClientModule,
    DriversService,
    UsersService,
    MethodOfPaymentService,
    VehicleService,
    DatePipe,
    InvoiceService,
    TripService,
    AccountService,
    TripDateService,
    UsefulToolsService,
    TripEditService,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: OwnHttpInterceptor,
      multi: true,
    }
  ],
  bootstrap: [AppComponent],
  entryComponents: [PopAlertComponent, PopupTextarea] // and add this here
})

export class AppModule { }
